import { useTranslation } from 'react-i18next';

interface Props {
  currentPage: 'clients' | 'devices' | 'mqttLogs' | 'settings';
  onNavigate: (page: 'clients' | 'devices' | 'mqttLogs' | 'settings') => void;
  user: any;
  onLogout: () => void;
  onThemeToggle: () => void;
  isDark: boolean;
}

export default function AdminSidebar({ currentPage, onNavigate, user, onLogout, onThemeToggle, isDark }: Props) {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language.startsWith('es') ? 'en' : 'es');
  };

  return (
    <div style={{ width: 220, background: 'var(--white)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      <div style={{ padding: '16px 14px 12px', borderBottom: '1px solid var(--border)' }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--dark)', letterSpacing: '0.1em' }}>DIMAS FARMING</div>
        <div style={{ fontSize: 9, color: 'var(--text-muted)', marginTop: 2 }}>{t('admin.consoleName')}</div>
      </div>

      {user && (
        <div style={{ padding: '10px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 9 }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'var(--dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 600, color: 'var(--green)', flexShrink: 0 }}>
            {user.email?.[0]?.toUpperCase() || 'U'}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--dark)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.name || user.email || 'Usuario'}
            </div>
            <div style={{ fontSize: 9, color: 'var(--text-muted)' }}>{t('sidebar.roles.super_admin')}</div>
          </div>
        </div>
      )}

      <div style={{ flex: 1, padding: '8px 6px', overflowY: 'auto' }}>
        <NavItem icon="🏢" label={t('sidebar.nav.tenants')} active={currentPage === 'clients'} onClick={() => onNavigate('clients')} />
        <NavItem icon="📡" label={t('sidebar.nav.devices')} active={currentPage === 'devices'} onClick={() => onNavigate('devices')} />
        <NavItem icon="📶" label={t('admin.mqtt.logs.navLabel')} active={currentPage === 'mqttLogs'} onClick={() => onNavigate('mqttLogs')} />
        <NavItem icon="⚙️" label={t('sidebar.nav.settings')} active={currentPage === 'settings'} onClick={() => onNavigate('settings')} />
      </div>

      <div style={{ padding: '12px 14px', borderTop: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            onClick={onThemeToggle}
            style={{ flex: 1, padding: '7px 8px', background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, fontSize: 11, color: 'var(--gray)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
          >
            <span>{isDark ? '☀️' : '🌙'}</span>
            <span>{isDark ? t('sidebar.lightMode') : t('sidebar.darkMode')}</span>
          </button>
          <button
            onClick={toggleLanguage}
            title={i18n.language.startsWith('es') ? 'Switch to English' : 'Cambiar a Español'}
            style={{ padding: '7px 10px', background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, fontSize: 11, fontWeight: 600, color: 'var(--gray)', cursor: 'pointer', flexShrink: 0 }}
          >
            {t('sidebar.langToggle')}
          </button>
        </div>
        <button
          onClick={onLogout}
          style={{ width: '100%', padding: '7px', background: 'transparent', border: '1px solid var(--border)', borderRadius: 6, fontSize: 12, color: 'var(--gray)', cursor: 'pointer' }}
        >
          {t('sidebar.logout')}
        </button>
      </div>
    </div>
  );
}

function NavItem({ icon, label, active, onClick }: { icon: string; label: string; active: boolean; onClick: () => void }) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 9,
        padding: '8px 10px', borderRadius: 7, cursor: 'pointer', transition: 'background 0.12s', marginBottom: 1,
        background: active ? 'var(--green-bg)' : 'transparent',
      }}
      onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'var(--bg)'; }}
      onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}
    >
      <span style={{ fontSize: 15, width: 18, textAlign: 'center' }}>{icon}</span>
      <span style={{ fontSize: 12, color: active ? 'var(--green-dk)' : 'var(--dark)', fontWeight: active ? 500 : 400, flex: 1 }}>{label}</span>
    </div>
  );
}
